'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("highchartExportPopinController", function ($scope, $element, $timeout, urlUtils, security, highchartUtils, highchartConfigUpdater) {
  var getUpdaterParameters = highchartConfigUpdater.getUpdaterParameters,
    applyConfigUpdate = highchartConfigUpdater.applyConfigUpdate;
  var copyChartConfig = function copyChartConfig(chart) {
    return highchartUtils.copyChartConfigForPopins(chart);
  };
  var originalChart = $scope.originalChart;
  var preprocessedConfig = copyChartConfig(originalChart);
  var exporting = preprocessedConfig.options && preprocessedConfig.options.exporting || originalChart && originalChart.options && originalChart.options.exporting || originalChart && originalChart.userOptions && originalChart.userOptions.exporting;
  var exportTitle = null;
  if (exporting && exporting.chartOptions && exporting.chartOptions.title) {
    exportTitle = exporting.chartOptions.title.text != null ? exporting.chartOptions.title.text : typeof exporting.chartOptions.title === 'string' ? exporting.chartOptions.title : null;
  }
  if (exportTitle) {
    var currentTitle = preprocessedConfig.title && preprocessedConfig.title.text || preprocessedConfig.options && preprocessedConfig.options.title && preprocessedConfig.options.title.text;
    if (!currentTitle) {
      if (!preprocessedConfig.title || _typeof(preprocessedConfig.title) !== 'object') {
        preprocessedConfig.title = {};
      }
      preprocessedConfig.title.text = exportTitle;
      if (preprocessedConfig.options) {
        preprocessedConfig.options.title = preprocessedConfig.options.title || {};
        preprocessedConfig.options.title.text = exportTitle;
      }
    }
  }
  function prepareChartConfig() {
    var config = angular.copy(preprocessedConfig);
    return _objectSpread({}, config, {
      series: _.filter(config.series, function (s) {
        return s.id !== "highcharts-navigator-series";
      }),
      options: _objectSpread({}, config.options, {
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        rangeSelector: {
          enabled: false
        }
      })
    });
  }
  $scope.exportedChartConfig = prepareChartConfig();
  $scope.chartType = preprocessedConfig.options.chart.type;
  var chartParams = $scope.chartParams = {};
  var initializeParameters = function initializeParameters() {
    chartParams = $scope.chartParams = getUpdaterParameters($scope.exportedChartConfig);
    if (exportTitle && !chartParams.title) {
      chartParams.title = exportTitle;
    }
  };
  $scope.updateChartConfig = function () {
    var chartConfig = prepareChartConfig();
    $scope.exportedChartConfig = applyConfigUpdate(chartConfig, chartParams);
    resizeChart();
  };
  var resizeChart = function resizeChart() {
    var maxHeight = 430,
      maxWidth = 820;
    var originalHeight = chartParams.height,
      originalWidth = chartParams.width,
      heightRatio = maxHeight / originalHeight,
      widthRatio = maxWidth / originalWidth,
      useHeightRatio = heightRatio != null && (widthRatio == null || heightRatio < widthRatio),
      effectiveRatio = useHeightRatio ? heightRatio : widthRatio,
      heightOffset = (maxHeight - originalHeight * effectiveRatio) / (2 * effectiveRatio),
      widthOffset = (maxWidth - originalWidth * effectiveRatio) / (2 * effectiveRatio);
    getChart().setSize(originalWidth, originalHeight, false);
    var scale = "scale(" + effectiveRatio + ")";
    var translateX = "translateX(" + widthOffset + "px)";
    var translateY = "translateY(" + heightOffset + "px)";
    var transform = scale + " " + translateX + " " + translateY;
    $element.find("div.highchart").css({
      "transform": transform,
      "transform-origin": "top left"
    });
  };

  // init
  $timeout(function () {
    initializeParameters();
    $scope.updateChartConfig();
  }, 0);

  // chart accessors
  var getChart = function () {
    var highchartCtrl = null;
    var getChartCtrl = function getChartCtrl() {
      if (highchartCtrl == null) {
        highchartCtrl = $element.find("div.highchart").controller("highchart");
      }
      return highchartCtrl;
    };
    return function () {
      return getChartCtrl().getChart();
    };
  }();

  // exporting
  var exportChart = function exportChart(mimetype) {
    var exportUrl = "/rest/highcharts/generate";
    getChart().exportChart({
      url: exportUrl + "?" + urlUtils.param(security.getTokens()),
      type: mimetype,
      width: chartParams.width,
      sourceWidth: chartParams.width,
      sourceHeight: chartParams.height
    });
  };
  $scope.exportToPdf = function () {
    return exportChart("application/pdf");
  };
  $scope.exportImage = function () {
    return exportChart("image/png");
  };
  $scope.exportImageSVG = function () {
    return exportChart("image/svg+xml");
  };
});
ngModule.directive("highchartExportPreview", function () {
  return {
    restrict: "A",
    require: ["highchart"],
    link: function link($scope, $el, $attrs, controllers) {
      var chartCtrl = controllers[0];
      chartCtrl.setAutoResize(false);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/exporter/highchartExportPopin.js
// module id = 2956
// module chunks = 13